import { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Collapse } from "reactstrap";
import "./style.scss";
import Icon from "../Icon";

function MobileLinkAccordion(props) {
  const { groups } = props;
  const [collapse, setCollapse] = useState(false);
  const toggle = i => () => setCollapse(collapse === i ? false : i);
  return (
    <div className={"mobile-link-accordeon"}>
      {groups.map((group, i) => {
        const open = collapse === i;
        return (
          <div className={"link-group"} key={i}>
            <h4 onClick={toggle(i)} className={classNames({ open })}>
              {group.title}{" "}
              <Icon className={"toggle"} name={open ? "minus" : "plus"} />
            </h4>
            <Collapse isOpen={open}>
              <ul>
                {group.links.map((link, j) => (
                  <li key={j}>{link}</li>
                ))}
              </ul>
            </Collapse>
          </div>
        );
      })}
    </div>
  );
}

MobileLinkAccordion.propTypes = {
  groups: PropTypes.array.isRequired
};

export default MobileLinkAccordion;
